"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hiddenPosition = exports.getPositionRelativeToNav = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wrapper = require("./Wrapper.style");
const positionWhenHidden = -1000;
const hiddenPosition = exports.hiddenPosition = {
  x: positionWhenHidden,
  y: positionWhenHidden,
  parentWidth: 0,
  parentX: null
};
const getPositionRelativeToNav = (navItem, positionToLeft, dropdownContainer, clickableDropDown) => {
  if (!navItem) return hiddenPosition;
  const navContainer = document.getElementById('nav-container');
  if (!navContainer) return hiddenPosition;
  const navItemBounds = navItem.getBoundingClientRect();
  const navBounds = navContainer.getBoundingClientRect();
  let x = positionToLeft ? navBounds.right - navItemBounds.right : navItemBounds.left - navBounds.left;
  let parentX = null;
  const spacer = 4;
  if (dropdownContainer) {
    const dropdownStyle = window.getComputedStyle(dropdownContainer);
    const dropdownBorderLeftWidth = parseFloat(dropdownStyle.borderLeftWidth);
    const dropdownBorderRightWidth = parseFloat(dropdownStyle.borderRightWidth);
    const containerRect = dropdownContainer.getBoundingClientRect();
    const halfSizeNavItem = navItemBounds.width / 2;
    const halfSizeContainer = (containerRect.width - dropdownBorderLeftWidth - dropdownBorderRightWidth) / 2;
    const xHalfSizeContainer = x + halfSizeNavItem - halfSizeContainer;
    if (positionToLeft) {
      if (navItemBounds.right - containerRect.width < navBounds.left) {
        parentX = halfSizeContainer - halfSizeNavItem - 1;
        x = xHalfSizeContainer;
      }
    } else if (navItemBounds.left + containerRect.width > navBounds.right) {
      parentX = halfSizeContainer - halfSizeNavItem - 1;
      x = xHalfSizeContainer;
    }
    //Tactical fix for Topics dropdown
    if (navItem.textContent === 'Topics') {
      parentX = halfSizeContainer - halfSizeNavItem - 1;
      x = xHalfSizeContainer;
    }
  }
  const navItemBoundsBottom = !clickableDropDown ? navItemBounds.bottom + spacer : navItemBounds.bottom;
  let y = Math.floor(navItemBoundsBottom - navBounds.top - 1);
  // positionToLeft means the item is in the services nav, and due to the fact the ul is absolutely
  // positioned and therefore this submenu becomes relative to that, we need to remove the offset
  // applied to the nav
  if (positionToLeft) {
    y -= 1;
  }
  return {
    x,
    y,
    parentWidth: navItemBounds.width,
    parentX
  };
};
exports.getPositionRelativeToNav = getPositionRelativeToNav;
const SubMenuWrapper = _ref => {
  let {
    children,
    parentNavItem,
    onMouseEnter,
    onMouseLeave,
    showing,
    positionToLeft,
    clickableDropDown,
    testId
  } = _ref;
  const divRef = (0, _react.useRef)(null);
  const {
    x,
    y,
    parentWidth,
    parentX
  } = getPositionRelativeToNav(parentNavItem, positionToLeft, divRef.current, clickableDropDown);
  return /*#__PURE__*/_react.default.createElement(_Wrapper.SubMenuContainer, {
    ref: divRef,
    sX: x,
    sY: y,
    parentWidth: parentWidth,
    parentX: parentX,
    positionToLeft: positionToLeft,
    clickableDropDown: clickableDropDown,
    showing: showing,
    "data-testid": testId,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
};
var _default = exports.default = SubMenuWrapper;